module.exports = __webpack_public_path__ + "svg/new-bankaxept-big.ee08e84ade6a37e72f650a22d023c61a.svg";